import { createSelector } from '@reduxjs/toolkit'
import { Country } from '@/models/app'
import { appSlice } from '../appSlice'

type Config = {
  assetsBase: string
  brandName: string
  infoEmailAddress: string
}

export const configSelector = createSelector(
  [appSlice.selectors.country, appSlice.selectors.isPool],
  (country, isPool): Config => {
    if (isPool) {
      return {
        assetsBase: import.meta.env.VITE_ASSETS_POOL_URL,
        brandName: 'inpiscina.it',
        infoEmailAddress: 'info@inpiscina.it',
      }
    }

    switch (country) {
      case Country.FR:
        return {
          assetsBase: import.meta.env.VITE_ASSETS_URL,
          brandName: 'Plages.fr',
          infoEmailAddress: 'info@plages.fr',
        }

      case Country.IT:
        return {
          assetsBase: import.meta.env.VITE_ASSETS_URL,
          brandName: 'Spiagge.it',
          infoEmailAddress: 'info@spiagge.it',
        }
    }
  }
)
